import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialFileState, TTempFileBody, TUploadDocumentType } from "./index";
import { getCurrentStep } from "@pages/HR/Employees/EmployeesPages/PersonalInfo/utils/getCurrentStep";

const initialState: IInitialFileState = {
    viewMode: "default",
    isModalOpen: {},
    currentUploadScreen: 0,
    tempFile: {
        type: null,
        fileType: "default",
        path: "",
    },

    paths: {
        front: "",
        back: "",
        selfie: "",
    },
    multipleFiles: {},
    selectedFileId: null,
};

export const fileSlice = createSlice({
    name: "file",
    initialState,
    reducers: {
        toggleViewMode(state) {
            if (state.viewMode === "default") {
                state.viewMode = "edit";
            } else {
                state.viewMode = "default";
            }
        },
        setIsModalOpen(
            state,
            action: PayloadAction<{
                open: boolean;
                type?: TUploadDocumentType;
                id?: string;
            }>
        ) {
            const { open, id = "default" } = action.payload;

            state.isModalOpen[id] = open;

            if (action.payload.id) {
                state.selectedFileId = action.payload.id;
            }

            state.currentUploadScreen = getCurrentStep(id, state);
        },
        setCurrentScreen(state, action: PayloadAction<number>) {
            state.currentUploadScreen = action.payload;
        },
        setTempFilePath(state, action: PayloadAction<TTempFileBody>) {
            if (action.payload) {
                state.tempFile = action.payload;
            }
        },
        clearTempFilePath(state) {
            state.tempFile = initialState.tempFile;
        },
        clearPaths(state) {
            state.paths = initialState.paths;
            state.multipleFiles = initialState.multipleFiles;
        },
        removePath(state, action: PayloadAction<TUploadDocumentType>) {
            if (action.payload) {
                state.paths[action.payload] = "";
            }
        },
        setDocumentPath(state, action: PayloadAction<TTempFileBody>) {
            console.log(action.payload);
            if (action.payload && action.payload.type && action.payload.path) {
                state.paths[action.payload.type] = action.payload.path;
            }
        },

        addFile(
            state,
            action: PayloadAction<{
                id: string;
                type: TUploadDocumentType;
                file: TTempFileBody;
            }>
        ) {
            const { id, type, file } = action.payload;
            state.multipleFiles[id] = {
                ...state.multipleFiles[id],
                [type]: file,
            };

            // state.currentUploadScreen = getCurrentStep(id, state) + 1;
        },

        updateFile(state, action: PayloadAction<{ id: string; file: Partial<TTempFileBody> }>) {
            const { id, file } = action.payload;
            if (state.multipleFiles[id]) {
                state.multipleFiles[id] = { ...state.multipleFiles[id], ...file };
            }
        },

        removeFile(state, action: PayloadAction<{ fileId: string; type: TUploadDocumentType }>) {
            const { fileId, type } = action.payload;
            delete state.multipleFiles[fileId][type];
            if (state.selectedFileId === fileId) {
                state.selectedFileId = null;
            }
        },

        setSelectedFile(state, action: PayloadAction<string | null>) {
            state.selectedFileId = action.payload;
        },

        clearAllFiles(state) {
            state.multipleFiles = {};
            state.selectedFileId = null;
        },
    },
});

export default fileSlice;
export const {
    toggleViewMode,
    setIsModalOpen,
    setCurrentScreen,
    setTempFilePath,
    clearTempFilePath,
    clearPaths,
    removePath,
    setDocumentPath,

    addFile,
    updateFile,
    removeFile,
    setSelectedFile,
    clearAllFiles,
} = fileSlice.actions;
